import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-sharp",
  "use": "icon-menu-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-menu-sharp\"><title>BottomMenu</title><path d=\"M64 384h384v-42.67H64zm0-106.67h384v-42.66H64zM64 128v42.67h384V128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol